import { BindAll } from 'lodash-decorators'
import type { Dictionary } from 'vue-router/types/router'
import { EnumTongHaoStatus } from '@xt/client/enums/kindred-spirit/index'
import { PagePagination } from '@xt/client/utils/infinite-loading/index'
import { EnumApiTonghao } from '@xt/client/api/kindred-spirit'
import { EnumApiHomework } from '@xt/client/api/homework'
import { $service } from '@xt/client/experimental/request/service'
import { toJS } from 'mobx'
import type { Moment, GuildJson } from '@xt/client/entities/kindred-spirit/kindred-spirit'
import { Guild } from './guild'
import { action, observable, computed } from 'mobx'
import $global from '@xt/client/store/global'
import singleServiceTime from '@xt/client/experimental/server-time'

type QueryParams = {
  active?: EnumTongHaoStatus | string
}

@BindAll()
export class ControllerTonghao {
  // 更多城市信息
  Guild = new Guild()

  @observable dataSource: GuildJson | null = null

  @computed
  get citiesJsonData() {
    return this.dataSource?.city
  }

  pagePagination = new PagePagination({
    url: EnumApiTonghao.Moments,
    omitBody: 'active',
    needCache: true,
    needLastId: false,
    pageSize: 20
  })

  public mapPagePagination(value: EnumTongHaoStatus) {
    this.pagePagination.updateStatus({
      url: value !== EnumTongHaoStatus.Follow ? EnumApiTonghao.Moments : EnumApiTonghao.FollowsMoments
    })
  }

  // 点赞
  public async onLikeMoment(moment: Moment) {
    if (moment.like === true) {
      throw new Error('你已经点过赞了')
    }

    this.likeItem(moment.id)

    const [, success] = await $service<boolean>({
      url: EnumApiHomework.MomentLike,
      method: 'PUT',
      data: { momentId: moment.id }
    })

    if (success === true) {
      return
    } else {
      this.cancelLikeItem(moment.id)
      throw new Error('点赞失败')
    }
  }

  // 格式化查询参数
  public formatQuery(routerQuery: Dictionary<string | (string | null)[]>): QueryParams {
    let params = {}

    switch (routerQuery.active) {
      case '0':
        params = {
          active: EnumTongHaoStatus.Follow
        }
        break
      case '1':
        params = {
          active: EnumTongHaoStatus.Discover
        }
        break
      case '2':
        params = {
          active: EnumTongHaoStatus.InkLightUpLife
        }
        break
      case '3':
        params = {
          active: EnumTongHaoStatus.GoodHomework
        }
        break
      case '4':
        params = {
          active: EnumTongHaoStatus.StudyInsight
        }
        break
      case '5':
        params = {
          active: EnumTongHaoStatus.BackToHoushan
        }
        break
      case '6':
        params = {
          active: EnumTongHaoStatus.SnackTime
        }
        break
      case '7':
        params = {
          active: EnumTongHaoStatus.XuantongGathering
        }
        break
      case '8':
        params = {
          active: EnumTongHaoStatus.ClassmateGathering
        }
        break
      case '9':
        params = {
          active: EnumTongHaoStatus.ClassmateWork
        }
        break
      case '10':
        params = {
          active: EnumTongHaoStatus.FenTong
        }
        break
      default:
        params = {
          active: EnumTongHaoStatus.Discover
        }
        break
    }

    return params
  }

  // 转换搜索参数
  public toSearchQuery(form: QueryParams): Record<keyof QueryParams, string> {
    const obj = {} as Record<keyof QueryParams, string>

    Object.keys(form).forEach(key => {
      if (form[key].toString() !== '') {
        obj[key] = form[key].toString()
      }
    })

    return obj
  }

  // 点赞请求操作
  public likeItem(id: string) {
    const oldList = [...toJS(this.pagePagination.dataSource)]
    const newList = oldList.map(item => {
      if (item.id === id) {
        item.like = true
        item.likeCount = typeof item.likeCount === 'number' ? item.likeCount + 1 : 1
      }
      return item
    })

    this.pagePagination.updateSource(newList, dataSource => {
      return dataSource.map(item => {
        if (item.id === id) {
          item.like = true
          item.likeCount = typeof item.likeCount === 'number' ? item.likeCount + 1 : 1
        }
        return item
      })
    })
  }

  // 取消点赞操作
  public cancelLikeItem(id: string) {
    const oldList = [...toJS(this.pagePagination.dataSource)]
    const newList = oldList.map(item => {
      if (item.id === id) {
        item.like = false
        item.likeCount = typeof item.likeCount === 'number' ? Math.max(0, item.likeCount - 1) : 0
      }
      return item
    })
    this.pagePagination.updateSource(newList)
  }

  // 删除
  public removeItem(id: string) {
    const oldList = [...toJS(this.pagePagination.dataSource)]
    const newList = oldList.filter(item => item.id !== id)
    this.pagePagination.updateSource(newList)
  }

  // 拉取json数据
  async loadJSON() {
    if (!!this.dataSource) return

    const [err, data] = await $service<GuildJson>({
      method: 'GET',
      url: '/mocks/guild-web.json',
      baseURL: $global.static
    })

    if (err) throw err

    this.updateDataSource(data)
  }

  @action
  updateDataSource(data: GuildJson) {
    this.dataSource = data
  }

  // 创建分桐
  public async initTonghao() {}

  // 桐学会管理页 - 获取已助力的人员列表
  public async getAssistList() {}

  // 待入群操作
  public async joinGroup() {}

  // 退出审核操作
  public async exitAudit() {}
}
